import { CFW_CURRENT_URL } from "@genericComponents/CFW.js";
import { GetProductAndLanguage } from "@genericComponents/Common.js";
import { InitializeCustomWorker } from "@genericComponents/InitializeCustomWorker.js";
import { GetState } from "@genericComponents/StoreToolkit.js";
import { User } from "@genericComponents/User.js";
export let initialHeaders = {};
export const SetInitialHeaders = (headers) => {
  initialHeaders = headers;
};
const MaintainDataWorker = async (
  method,
  paramUrl,
  paramBody,
  headers = {},
  strictHeaders = false,
  isFormData = false,
  postEvent = null,
) => {
  if (!headers) {
    headers = {};
  }
  headers = { ...initialHeaders, ...headers };
  if (!strictHeaders) {
    headers["Accept-Encoding"] = "*";
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
  }
  const abortController = new AbortController();
  const { productCode, languageCode } = GetProductAndLanguage(
    GetState(CFW_CURRENT_URL, headers.currentUrl),
  );
  const requestOptions = {
    method: method,
    headers: {
      ...headers,
      Lang: languageCode,
      App: productCode.toLowerCase(),
    },
  };
  if (method !== "GET") {
    requestOptions.body =
      typeof window === "undefined"
        ? paramBody
          ? JSON.stringify(paramBody)
          : null
        : paramBody;
  }
  requestOptions.headers["x-access-token"] = User.AccessToken();
  if (typeof window === "undefined") {
    requestOptions.signal = abortController.signal;
    return await fetch(paramUrl, { ...requestOptions })
      .then(async (res) => {
        if (isFormData) {
          return await res;
        }
        return await res.json();
      })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.Message ?? "An error has occurred");
        } else if (res?.Results) {
          return res.Results;
        }
        return res;
      })
      .then((res) => {
        if (postEvent) {
          return postEvent(res);
        }
        return res;
      })
      .catch((error) => {
        abortController.abort({
          paramUrl,
          message: "Looks like there was a problem on doing post: \r\n",
          errorMessage: JSON.stringify(error.message),
          body: requestOptions.body,
        });
        return null;
      });
  } else {
    return new Promise((resolve, reject) => {
      const postWorker = InitializeCustomWorker(
        (responseAsJson) => {
          if (postEvent) {
            resolve(postEvent(responseAsJson));
          }
          resolve(responseAsJson);
        },
        (error) => {
          reject(error);
          console.log("Looks like there was a problem:", error);
        },
      );
      const payload = postWorker.payload(paramUrl, requestOptions, 0);
      postWorker.worker.postMessage(payload);
    });
  }
};
export const PostDataWorker = async (
  paramUrl,
  paramBody,
  headers = {},
  strictHeaders = false,
  isFormData = false,
  postEvent = null,
) => {
  if (typeof window === "undefined") {
    return await MaintainDataWorker(
      "POST",
      paramUrl,
      paramBody,
      headers,
      strictHeaders,
      isFormData,
      postEvent,
    );
  }
  return MaintainDataWorker(
    "POST",
    paramUrl,
    paramBody,
    headers,
    strictHeaders,
    isFormData,
    postEvent,
  );
};
export const GetDataWorker = async (
  paramUrl,
  headers = {},
  strictHeaders = false,
  isFormData = false,
  postEvent = null,
) => {
  if (typeof window === "undefined") {
    return await MaintainDataWorker(
      "GET",
      paramUrl,
      null,
      headers,
      strictHeaders,
      isFormData,
      postEvent,
    );
  }
  return MaintainDataWorker(
    "GET",
    paramUrl,
    null,
    headers,
    strictHeaders,
    isFormData,
    postEvent,
  );
};
